<template>
	<div class='footer'>

		<div style="margin-right:50px">
			<img style="width: 200px" src="../assets/qcode.png" />
		</div>
		<div style="display: flex;flex-direction: column;justify-content: space-around">
			<div style="display: flex;">
				<img style="margin-right: 10px;width: 80px" src="../assets/logo-1.png">
				<div style="display: flex;flex-direction: column">
					<p style="color: #FFFFFF">最美证件照制作</p>
					<span style="letter-spacing:10px">十秒制作合格的证件照</span>
				</div>
			</div>
			<div style="display: flex;margin-top: 40px">
				<div @click="downloadForIos" class="icon">
					<img style="width: 20px;opacity:0.3;" src="../assets/download_btn_iphone.png"/>
					<span style="font-size: 11px;margin-left: 5px">iPhone 版下载</span>
				</div>
				<div @click="downloadForAndroid" class="icon">
					<img style="width: 20px;opacity:0.3;" src="../assets/download_btn_android.png"/>
					<span style="font-size: 11px;margin-left: 5px">Android 版下载</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageFooter',
	methods:{
		openPrivacy:function(){
			window.open("http://www.id-photo-verify.com/privacy-zuimei-personal/")
		},
		openMainBody:function(){
			window.open("https://id-photo-verify.com/leqi/")
		},
		downloadForIos:function(){
			window.open("https://apps.apple.com/cn/app/id1439173462")
		},
		downloadForAndroid:function(){
			window.open("https://sj.qq.com/myapp/detail.htm?apkName=com.leqi.zuimeiphoto")
		}

	},
}
</script>

<style scoped="scoped">
	.footer{
		width: 100%;
		height: 300px;
		background-color: #282547;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	span{
		color: rgba(255, 255, 255, 0.5);
	}
	.icon{
		display: flex;
		align-items: center;
		border: 1px solid rgba(255, 255, 255, 0.5);
		padding: 10px;
		margin-right: 30px;
		cursor: pointer;
	}
</style>
